import AsyncSelect from "react-select/async";
import { useAppV3 } from "contexts/v3/BookingContextV3";
import { useMemo, useState, useEffect, useRef } from "react";

/**
 * 🔥 Komponen Select Asinkronis (Bisa dipakai di Label, Agent, dll.)
 * @param {Function} fetchOptions - Fungsi untuk mengambil data dari API.
 * @param {string} valueKey - Key untuk update filter di useAppV3.
 * @param {string} placeholder - Placeholder untuk Select.
 * @param {boolean} isMulti - Jika true, bisa pilih lebih dari satu.
 */
const AsyncSelectComponent = ({ fetchOptions, valueKey, placeholder, isMulti = false }) => {
  const { updateFilter, filterOptions } = useAppV3(); // ✅ Ambil filter & updateFilter dari useAppV3
  const [defaultOptions, setDefaultOptions] = useState([]); // 🔥 Simpan 10 data awal
  const hasFetched = useRef(false); // 🔥 Hindari looping dengan useRef

  // 🔥 Ambil 10 data pertama saat komponen di-mount (hanya sekali)
  useEffect(() => {
    if (!hasFetched.current) {
      hasFetched.current = true; // Set flag agar tidak refetch
      fetchOptions("").then(setDefaultOptions);
    }
  }, [fetchOptions]);

  // 🔥 Load options berdasarkan input user
  const loadOptions = async (inputValue, callback) => {
    const options = await fetchOptions(inputValue); // Panggil API dengan input user
    callback(options);
  };

  // 🔹 Temukan nilai yang sudah dipilih tanpa looping berlebih
  const selectedValue = useMemo(() => {
    if (isMulti) {
      return filterOptions.filters[valueKey]?.map((id) =>
        defaultOptions.find((opt) => opt.value === id) || { value: id, label: `ID: ${id}` }
      ) || [];
    }
    const selected = defaultOptions.find((opt) => opt.value === filterOptions.filters[valueKey]);
    return selected || (filterOptions.filters[valueKey] ? { value: filterOptions.filters[valueKey], label: `ID: ${filterOptions.filters[valueKey]}` } : null);
  }, [filterOptions.filters, valueKey, isMulti, defaultOptions]);

  return (
    <AsyncSelect
      cacheOptions
      loadOptions={loadOptions} // 🔥 Panggil API saat user mengetik
      defaultOptions={defaultOptions} // ✅ Menampilkan 10 data awal
      value={selectedValue} // ✅ Tampilkan nama yang dipilih dengan benar
      onChange={(selected) => {
        updateFilter(valueKey, isMulti ? selected.map((s) => s.value) : selected?.value || ""); // 🚀 Kirim ke useAppV3
      }}
      isClearable
      isMulti={isMulti} // 🔥 Bisa pilih lebih dari satu
      placeholder={placeholder}
      menuPortalTarget={document.body}
      styles={{ menuPortal: (base) => ({ ...base, zIndex: 1050 }) }}
    />
  );
};

export default AsyncSelectComponent;
